import React, { useContext, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react";
import { UI } from "@wwimmo/ui";
import { AssembliesList } from "src/screens/assemblies/AssembliesList";
import { useParams } from "react-router";
import { ScreenWithTiles } from "src/components/screenWithTiles/ScreenWithTiles";
import { ScreenType } from "src/api/tiles";

interface Params {
    realestateid: string;
}

const CoownerAssembliesBase = () => {
    const { t } = useTranslation();
    const { navStore, assemblyStore } = useContext(RootStoreContext);
    const { realestateid } = useParams<Params>();

    useEffect(() => {
        navStore.setTitle(t("screens.assemblies.sidebar_title"));
        navStore.setActionButtonMiddle(null);
        navStore.setActionButtonRight(null);
        navStore.setBackbutton(null);
    }, [navStore, t]);

    useEffect(() => {
        assemblyStore.loadAllAssemblies(realestateid);
        // eslint-disable-next-line
    }, []);

    return (
        <ScreenWithTiles
            title={t("screens.assemblies.sidebar_title")}
            screenId={ScreenType.DOCUMENTS}
            realestateid={realestateid}
        >
            <UI.Card>
                <AssembliesList realestateId={realestateid} />
            </UI.Card>
        </ScreenWithTiles>
    );
};

export const CoownerAssemblies = Sentry.withProfiler(observer(CoownerAssembliesBase));
